import { donationDelete } from '@/entities/donations'
import { type GetApiDonationsByDateQueryParams } from '@/shared/api'
import { createStore, sample } from 'effector'
import { createGate } from 'effector-react'

import {
  type DonationsByDateQueryModelWithPagination,
  createDonationsByDateQueryModel,
} from '../lib/donations-by-date-model'

interface DonationsByDateTableGateProps {
  params?: GetApiDonationsByDateQueryParams
}
export const DonationsByDateTableGate =
  createGate<DonationsByDateTableGateProps>()

export const DonationsByDateTableDonationsByDateQueryModel =
  createDonationsByDateQueryModel({
    usePagination: true,
    accumulate: false,
  }) as DonationsByDateQueryModelWithPagination
const { availableSet, unavailableSet } =
  DonationsByDateTableDonationsByDateQueryModel
export const {
  //   Query
  query: donationsByDateTableQuery,
  //   Init
  filtersInit: donationsByDateTableFiltersInit,
  //   Search
  $search: $donationsByDateTableSearch,
  searchChanged: donationsByDateTableSearchChanged,
  searchReset: donationsByDateTableSearchReset,
  //   Sort
  $sort: $donationsByDateTableSort,
  sortChanged: donationsByDateTableSortChanged,
  sortReset: donationsByDateTableSortReset,
  //   Pagination
  $page: $donationsByDateTablePage,
  pageChanged: donationsByDateTablePageChanged,
  pageReset: donationsByDateTablePageReset,
  $pageSize: $donationsByDateTablePageSize,
  pageSizeChanged: donationsByDateTablePageSizeChanged,
  //   Refresh
  refreshed: donationsByDateTableRefreshed,
} = DonationsByDateTableDonationsByDateQueryModel

export const $donationsByDateTableSearchInputValue = createStore('')
  .on(donationsByDateTableSearchChanged, (_, q) => q)
  .reset(donationsByDateTableSearchReset)

sample({
  clock: DonationsByDateTableGate.open,
  target: availableSet,
})

sample({
  source: DonationsByDateTableGate.state,
  clock: availableSet,
  fn: ({ params }) => params || {},
  target: donationsByDateTableFiltersInit,
})

sample({
  clock: DonationsByDateTableGate.close,
  target: unavailableSet,
})

sample({
  clock: donationDelete.finished.success,
  target: donationsByDateTableRefreshed,
})
